import { List, styled } from "@mui/material";
import { COLORS } from "../../constants/colors";

const StyledList = styled(List, {
  shouldForwardProp: (prop) => prop !== "maxHeight",
})<{ maxHeight?: string }>`
  padding: 0;
  overflow-y: auto;
  position: relative;
  max-height: ${(props) => props.maxHeight || "100%"};

  & {
    color: ${COLORS.TEXT_SECONDARY};
  }

  & .collapse-header span {
    font-weight: 500;
  }

  & .MuiListItemButton-root {
    padding: 4px 8px;
  }

  & .MuiListItemButton-root:hover {
    background-color: ${COLORS.SURFACE_HOVER};
  }

  & .Mui-selected {
    background-color: ${COLORS.SURFACE_SELECTED};

    & span {
      font-weight: 500;
    }
  }

  & .MuiCollapse-root {
    padding-left: 10px;
  }
`;

export { StyledList };
